@if (hasInwardStops || hasOutwardStops) {
  <div class="wrapper" [class.dark]="darkMode">
    <mat-accordion>
      <mat-expansion-panel id="rail-journey">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span i18n="@@basketPanelTotalShowDetails">Show details</span>
            <div class="visuallyhidden">
              <div>
                - {{ railOutwardSummary.departureStationName }} To
                {{ railOutwardSummary.arrivalStationName }}
              </div>
              <div>
                {{ railOutwardSummary.departureDateTime | sabsDate: 1 }}
                {{ railOutwardSummary.departureDateTime | sabsTimePipe: 'timeString' }}
              </div>
            </div>
          </mat-panel-title>
          <mat-panel-description> </mat-panel-description>
        </mat-expansion-panel-header>
        @if (hasOutwardStops) {
          <div class="summary">
            <div>
              {{ railOutwardSummary.departureStationName }} To
              {{ railOutwardSummary.arrivalStationName }}
            </div>
            <div>
              {{
                totalTimeJourney(
                  railOutwardSummary.departureDateTime,
                  railOutwardSummary.arrivalDateTime
                )
              }}
            </div>
          </div>
          <ul>
            @for (leg of railOutwardStops; track leg) {
              <li>
                <div class="time">{{ leg.departureDateTime | sabsTimePipe: 'timeString' }}</div>
                <div class="location">
                  {{ leg.departureStationName }}&nbsp;<span>to</span>&nbsp;{{
                    leg.arrivalStationName
                  }}
                </div>
              </li>
            }
          </ul>
        }
        @if (hasInwardStops) {
          <div class="summary">
            <div>
              {{ railInwardSummary.departureStationName }} To
              {{ railInwardSummary.arrivalStationName }}
            </div>
            <div>
              {{
                totalTimeJourney(
                  railInwardSummary.departureDateTime,
                  railInwardSummary.arrivalDateTime
                )
              }}
            </div>
          </div>
          <ul>
            @for (leg of railInwardStops; track leg) {
              <li>
                <div class="time">{{ leg.departureDateTime | sabsTimePipe: 'timeString' }}</div>
                <div class="location">
                  {{ leg.departureStationName }}&nbsp;<span>to</span>&nbsp;{{
                    leg.arrivalStationName
                  }}
                </div>
              </li>
            }
          </ul>
        }
      </mat-expansion-panel>
    </mat-accordion>
  </div>
}
